"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=user-stat.model.js.map